// TODO - duplicate code, need to refactor into generic components
import React, { useState, useEffect, useCallback } from 'react';

import { Link } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Add } from '@mesh.ai/rabbit';
import ImageUpload from 'components/ImageUpload';
import { useDispatch } from 'react-redux';
import { StyledPanelHeader, StyledDivider, StyledButtonContainer } from 'screens/admin/Objectives/styles';
import styled from 'styled-components';
import { StyledDrawer, HeadingText } from 'styles/admin';
import {
  StyledTypography,
  ColoredCircularProgress,
  VerticalFlexContainer,
  VerticallyAlignedFlexContainer,
  NewStyledIconContainer,
} from 'styles/common';

import { Cross } from 'assets/assetsV1/iconComponents';

import { sampleCompetencyFileURI, sampleCompetencyFunctionAndRoleFileURI } from 'constants/ProjectConstants';

import { uploadCompetenciesCSV } from 'services/admin';
import { showSuccessSnackbar, showErrorSnackbar } from 'services/snackbar';

import { Button } from 'uiToolkitV1/Button';
import { TextLabel } from 'uiToolkitV1/Typography';

import { COMPETENCY_SETTINGS_TYPE } from '..';

const CompetenciesUploadSidePanel = ({ open, onCancel, onSuccess, competencySettingsType }) => {
  const dispatch = useDispatch();
  const [sendEmail, setSendEmail] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleKeyDown = ({ keyCode }) => {
    if (keyCode === 27) onCancel();
  };

  const validateUploadFile = (file) => {
    if (file.size > 10 * 1000 * 1000) {
      const error = 'file size cannot be more than 10 mb.';
      dispatch(showErrorSnackbar(error));
      return false;
    }
    return true;
  };

  const selectUploadFile = (file) => {
    if (validateUploadFile(file)) setSelectedFile(file);
  };

  const uploadFile = () => {
    const file = selectedFile;
    setUploading(true);

    uploadCompetenciesCSV(file, sendEmail)
      .then((_) => {
        dispatch(showSuccessSnackbar('File upload successful. Please refresh to see updated data.', 3000));
        onSuccess();
      })
      .catch((err) => {
        console.log('upload error', err.message);
        dispatch(showErrorSnackbar(err.message, 5000));
      })
      .finally(() => setUploading(false));
  };

  const resetState = useCallback(() => {
    setSendEmail(true);
    setSelectedFile(null);
    setUploading(false);
  });

  useEffect(() => {
    // on close of side Panel, clear the state.
    if (!open) {
      resetState();
    }
  }, [open]);

  return (
    <StyledDrawer anchor="right" open={open} ModalProps={{ onBackdropClick: onCancel }} onKeyDown={handleKeyDown}>
      <StyledPanelHeader>
        <HeadingText>Bulk upload competencies</HeadingText>
        <Button onClick={() => onCancel()} StartIcon={Cross}>
          Cancel
        </Button>
      </StyledPanelHeader>
      <StyledDivider />

      <VerticalFlexContainer>
        <div>
          <StyledTypography weight="bold" variant="body1">
            Import Competency name, Description, etc from a CSV file.
          </StyledTypography>
          {competencySettingsType !== COMPETENCY_SETTINGS_TYPE.ORG && (
            <TextLabel>Note: We don't support adding bullet points in bulk upload</TextLabel>
          )}

          <VerticallyAlignedFlexContainer topGutter={3} bottomGutter={3} leftGutter={1} rightGutter={1}>
            <ImageUpload
              setFile={selectUploadFile}
              accept=".csv"
              icon={
                <Button variant="outlined" mr={2} w="120px" StartIcon={Add}>
                  Choose File
                </Button>
              }
            />
            <StyledTypography color="textSecondary">
              {selectedFile === null ? 'No File Chosen' : selectedFile.name}
            </StyledTypography>
          </VerticallyAlignedFlexContainer>

          <StyledTypography variant="body1" color="textSecondary">
            <NewStyledIconContainer color="textSecondary" size="header">
              <StyledInfoIcon />
            </NewStyledIconContainer>
            {`Please `}
            <Link
              download="CSVSample.csv"
              href={
                competencySettingsType === COMPETENCY_SETTINGS_TYPE.ORG
                  ? sampleCompetencyFileURI
                  : sampleCompetencyFunctionAndRoleFileURI
              }
              color="primary"
            >
              download
            </Link>
            {` our sample file to refer to the upload format.`}
          </StyledTypography>
        </div>

        <div>
          <StyledButtonContainer>
            <Button onClick={uploadFile} isDisabled={selectedFile === null}>
              {uploading ? (
                <ColoredCircularProgress size="tiny" />
              ) : (
                <StyledTypography color="white">Upload File</StyledTypography>
              )}
            </Button>
          </StyledButtonContainer>
        </div>
      </VerticalFlexContainer>
    </StyledDrawer>
  );
};

const StyledInfoIcon = styled(InfoOutlinedIcon)`
  margin-bottom: -3px;
  margin-right: 2px;
`;

export { CompetenciesUploadSidePanel };
